<template>
  <div class="machines-index d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="machines/map"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :map="mapBounds"
    ></filtered-data>
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">
          Автоматы
        </h1>
        <machine-list-map-tabs class="mx-2" v-if="data"></machine-list-map-tabs>
        <btn-filters
          :data="data"
          endpoint="machines/map"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>
    <div class="machines-index-map bg-light flex-grow-1">
      <div class="machines-index-map-map" ref="map"></div>

      <div ref="balloonContent" class="d-none">
        <balloon :machine="machine"></balloon>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { map, difference, debounce } from 'lodash'
  import ymap from '../../ymap'
  import api from '@/api'

  export default {
    metaInfo: {title: 'Карта'},
    data () {
      return {
        map: null,
        placemarks: {},
        bounds: null,
        machine: null,
        filtersValue: null,
        data: null,
        loading: false,
        hasMore: true,
        sort: null,
        mapBounds: null,
      }
    },
    watch: {
      data () {
        this.renderPlacemarks()
      },
    },
    methods: {
      renderPlacemarks () {
        ymap().then(ymaps => {
          const placedIds = Object.keys(this.placemarks)
          const currentIds = map(this.data.data, m => String(m.id))

          difference(placedIds, currentIds).forEach((idToRemove) => {
            // console.log(`removing id ${idToRemove}`)
            this.map.geoObjects.remove(this.placemarks[idToRemove])
            delete this.placemarks[idToRemove]
          })

          this.$nextTick(() => {
            this.data.data.forEach((machine, index) => {
              if (this.placemarks[machine.id]) return
              if (!machine.location) return

              this.placemarks[machine.id] = new ymaps.Placemark([machine.location.lat, machine.location.lon], {
                hintContent: machine.serial_number,
                balloonContent: 'Загрузка...',
                balloonPane: 'outerBalloon',
                machineId: machine.id,
              }, {
                preset: `islands#${machine.map_color}Icon`,
              })

              // see https://tech.yandex.com/maps/jsbox/2.1/balloon_ajax
              this.placemarks[machine.id].events.add('balloonopen', (e) => {
                this.placemarks[machine.id].properties.set('balloonContent', 'Загрузка...')
                api.get(`machines/${machine.id}`, {}).then(({data}) => {
                  this.machine = data.data
                  this.$nextTick(() => {
                    this.placemarks[machine.id].properties.set('balloonContent', this.$refs.balloonContent.innerHTML)
                  })
                })
              })

              this.map.geoObjects.add(this.placemarks[machine.id])
            })
          })
        })
      },
      getCenter () {
        return window.localStorage.getItem('ymapCenter') !== null ? window.localStorage.getItem('ymapCenter').split(' ') : [55.711863, 37.388753]
      },
      getZoom () {
        return window.localStorage.getItem('ymapZoom') !== null ? window.localStorage.getItem('ymapZoom') : 11
      },
      newBounds: debounce(function (bounds) {
        this.mapBounds = bounds
      }, 250)
    },
    mounted () {
      const self = this
      $(this.$refs.map).on('click', '.btn', function (e) {
        e.preventDefault()
        self.$router.push($(this).data('href'))
      })

      ymap().then(ymaps => {
        this.map = new ymaps.Map(this.$refs.map, {
          center: this.getCenter(),
          zoom: this.getZoom(),
          controls: ['fullscreenControl', 'geolocationControl', 'zoomControl'],
          // behaviors: [],
        }, {searchControlProvider: 'yandex#search'})

        this.map.events.add('boundschange', (e) => {
          this.bounds = e.get('newBounds')
          this.newBounds(e.get('newBounds'))
          window.localStorage.setItem('ymapCenter', e.get('newCenter').join(' '))
          window.localStorage.setItem('ymapZoom', e.get('newZoom'))
        })
        this.bounds = this.map.getBounds()
        this.newBounds(this.map.getBounds())

        this.renderPlacemarks()
      })
    },
    beforeDestroy () {
      if (this.map) this.map.destroy()
      this.newBounds(null)
    },
  }
</script>

<style lang="scss">
  .machines-index-map {
    position: relative;
  }
  .machines-index-map-map {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/map.vue